import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/left.png'
import _imports_1 from '../assets/img/right.png'


const _hoisted_1 = { class: "page-home" }
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "info-box-top" }, null, -1)
const _hoisted_4 = { class: "info-box-wrapper" }
const _hoisted_5 = { class: "info-other" }
const _hoisted_6 = { class: "info-other-top" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon left"
}, null, -1)
const _hoisted_8 = { class: "center" }
const _hoisted_9 = {
  key: 0,
  class: "name"
}
const _hoisted_10 = { class: "center-bottom" }
const _hoisted_11 = { class: "num" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "限量", -1)
const _hoisted_13 = {
  key: 0,
  class: "group set"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon"
}, null, -1)
const _hoisted_15 = { class: "info-other-price" }
const _hoisted_16 = {
  key: 0,
  class: "price"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "num"
}
const _hoisted_19 = {
  key: 0,
  class: "info-other-bottom cursor"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "链上信息 ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "more" }, ">", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "info-detail-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line" }),
  /*#__PURE__*/_createElementVNode("span", null, "详细信息"),
  /*#__PURE__*/_createElementVNode("span", { class: "line" })
], -1)
const _hoisted_24 = {
  key: 0,
  class: "info-detail-box"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "藏品描述", -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 1,
  class: "info-detail-box"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "藏品故事", -1)
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "lian-content" }
const _hoisted_31 = { class: "group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "商品标识:", -1)
const _hoisted_33 = { class: "content" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "zhu" }, "注：商品标识是本数字藏品在区块链上的唯一ID", -1)
const _hoisted_35 = { class: "group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "交易哈希：", -1)
const _hoisted_37 = { class: "content" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "zhu" }, "注：交易哈希是您拥有本数字藏品所有权的证明", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_model = _resolveComponent("model")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "show-box",
      style: _normalizeStyle([_ctx.infoData && (_ctx.infoData.img_bg_url?{backgroundImage: 'url('+_ctx.infoData.img_bg_url+')',backgroundColor:'#000'}:{backgroundColor:'#000'})])
    }, [
      (_ctx.modelData)
        ? (_openBlock(), _createBlock(_component_model, {
            key: 0,
            data: _ctx.modelData,
            isLoading: _ctx.isLoading,
            onLoadedevent: _ctx.loaded
          }, null, 8, ["data", "isLoading", "onLoadedevent"]))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.infoData.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.infoData.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(_ctx.infoData.num) + "件", 1)
                ]),
                (_ctx.infoData.set_name)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.infoData.set_name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.infoData.price>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.infoData.priceString)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.infoData.priceString), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.infoData.is_collect && ( _ctx.infoData.left_num > 0 || _ctx.infoData.left_num == 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, "剩余" + _toDisplayString(_ctx.infoData.left_num) + "件", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.infoData.is_collect)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: "group lian",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInfo()))
                }, _hoisted_22)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_23,
        (_ctx.infoData.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("p", {
                class: "content",
                innerHTML: _ctx.infoData.description
              }, null, 8, _hoisted_26)
            ]))
          : _createCommentVNode("", true),
        (_ctx.infoData.story)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("p", {
                class: "content",
                innerHTML: _ctx.infoData.story
              }, null, 8, _hoisted_29)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.infoFlag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lian-box",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openInfo()), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              (_ctx.infoData.goods_id )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "copy",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy(_ctx.infoData.goods_id)))
                  }, "复制"))
                : _createCommentVNode("", true),
              _hoisted_32,
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.infoData.goods_id || '处理中...'), 1),
              _hoisted_34
            ]),
            _createElementVNode("div", _hoisted_35, [
              (_ctx.infoData.block_hash )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "copy",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copy(_ctx.infoData.block_hash)))
                  }, "复制"))
                : _createCommentVNode("", true),
              _hoisted_36,
              _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.infoData.block_hash || '处理中...'), 1),
              _hoisted_38
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}